export default defineNuxtPlugin((nuxtApp) => {
	const runtimeConfig = useRuntimeConfig()
	const { $apiHelper } = useNuxtApp()

	const buildApiUrl = (appendPath) => {
		return runtimeConfig.public.SERVICES.MOTHERSHIP_API_URL + "orders/" + appendPath
	}

	nuxtApp.provide("orderApiService", {
		$getUserOrder: async (orderId, successHandler) => {
			const url = buildApiUrl(`${orderId}`)

			const requestOptions = {}
			requestOptions.method = "GET"
			requestOptions.headers = $apiHelper.$authedRequestHeader()

			$apiHelper.$performRequest(url, requestOptions, successHandler)
		},

		$resendOrderReceipt: async (orderId, successHandler) => {
			const url = buildApiUrl(`${orderId}/resend-receipt`)

			const requestOptions = {}
			requestOptions.method = "POST"
			requestOptions.headers = $apiHelper.$authedRequestHeader()

			$apiHelper.$performRequest(url, requestOptions, successHandler)
		},

		$updateOrderPaymentMethod: async (orderId, requestBody, successHandler) => {
			const url = buildApiUrl(`${orderId}/payment-method`)

			const requestOptions = {}
			requestOptions.method = "POST"
			requestOptions.headers = $apiHelper.$authedRequestHeader()
			requestOptions.body = requestBody

			$apiHelper.$performRequest(url, requestOptions, successHandler)
		},

		$payInstallmentNow: async (orderId, paymentId, requestBody, successHandler) => {
			const url = buildApiUrl(`${orderId}/payments/${paymentId}/pay`)

			const requestOptions = {}
			requestOptions.method = "POST"
			requestOptions.headers = $apiHelper.$authedRequestHeader()
			requestOptions.body = requestBody

			$apiHelper.$performRequest(url, requestOptions, successHandler)
		},

		$updatePaymentDueDate: async (orderId, paymentId, requestBody, successHandler) => {
			const url = buildApiUrl(`${orderId}/payments/${paymentId}/change-due-date`)

			const requestOptions = {}
			requestOptions.method = "POST"
			requestOptions.headers = $apiHelper.$authedRequestHeader()
			requestOptions.body = requestBody

			$apiHelper.$performRequest(url, requestOptions, successHandler)
		},
	})
})
